<template>
  <section class="ctn">
    <header class="header left">
      <router-link class="paper-action" :to="{ path: '/users' }"><heim-icon icon="arrow-back"></heim-icon><span>{{ $t('back') }}</span></router-link>
    </header>
    <heim-card>
      <header class="header left">
        <h1>{{$t('newUser')}}</h1>
      </header>
      <main>
        <form @submit.prevent="handleForm">
            <div class="row">
                <span class="label">{{$t('user')}}</span>
                <div class="inputs">
                    <heim-input :label="$t('name')  + '*'" name="name" placeholder="e.g : Name" v-model="name" v-validate="'required'"></heim-input>
                     <span v-show="errors.has('name')" class="help is-danger"><heim-icon class="icon" icon="error"></heim-icon>{{ errors.first('name') }}</span>
                    <heim-input :label="$t('email')  + '*'" name="email" placeholder="e.g : Email" v-model="email" v-validate="'required|email'"></heim-input>
                     <span v-show="errors.has('email')" class="help is-danger"><heim-icon class="icon" icon="error"></heim-icon>{{ errors.first('email') }}</span>
                    <heim-input :label="$t('password')  + '*'" type="password" name="password" v-model="password" v-validate="'required|min:5'" ref="password"></heim-input>
                     <span v-show="errors.has('password')" class="help is-danger"><heim-icon class="icon" icon="error"></heim-icon>{{ errors.first('password') }}</span>
                    <!-- <heim-input :label="$t('confirmationPassword')  + '*'" v-validate="'required|confirmed:password'" name="password_confirmation" type="password" :class="{'is-danger': errors.has('password_confirmation')}" data-vv-as="password"></heim-input>
                    <span v-show="errors.has('password_confirmation')" class="help is-danger"><heim-icon class="icon" icon="error"></heim-icon>{{ errors.first('password_confirmation') }}</span> -->
                </div>
            </div>
          <footer>
            <heim-button :disabled="errors.any()" type="submit">{{ $t('save') }}</heim-button>
          </footer>
        </form>
      </main>
    </heim-card>
  </section>
</template>

<script>
import Vue from "vue";
import HeimInput from "@/components/form/input/text/heim-input.vue";
import HeimButton from "@/components/form/button/heim-button.vue";
import HeimCard from "@/components/layout/card/heim-card.vue";
import HeimIcon from "@/components/icon/heim-icon.vue";
import VeeValidate from "vee-validate";

Vue.use(VeeValidate);

import { mapState } from "vuex";
export default {
  name: "UsersNew",
  components: {
    HeimInput,
    HeimButton,
    HeimCard,
    HeimIcon
  },
  mounted() {
    this.$store.dispatch("getUsers");
    this.$store.dispatch("setTitle", "Create user");
  },
  data() {
    return {
      name: "",
      email: "",
      password: ""
    };
  },
  computed: {
    ...mapState({ users: state => state.usersState.users })
  },
  methods: {
    async handleForm() {
      const data = await this.$store.dispatch("createUser", {
        name: this.name,
        email: this.email,
        password: this.password
      });

      this.$validator.validateAll().then(result => {
        if (result && data.id) {
          this.$store.dispatch("setToastMessage", {
            message: "newUsercreated"
          });
          this.$store.dispatch("setToastMode", {});
          this.$store.dispatch("setOpenToast", { opened: true });
          this.$router.push({ path: `/users/${data.id}/details` });
        }
      });
    }
  }
};
</script>

<style>
input.paper-input {
  background: var(--heim-grey-color);
  width: 100%;
  display: block;
  padding: 0.3em 0.4em;
  font-size: 0.9em;
  border-radius: 3px;
  border: solid 1px #ededed;
  outline: none;
  transition: box-shadow 0.3s var(--heim-transition);
  margin-bottom: 0.8em;
}
input.paper-input:hover,
input.paper-input:focus {
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
}
.heim-input[icon] input.paper-input {
  padding-right: 32px;
}

.date-input {
  margin-bottom: 20px;
}

.heim-input {
  max-width: 32em;
}

.heim-input input {
  width: 100%;
}

input.paper-input {
  background: var(--heim-grey-color);
  width: 100%;
  display: block;
  padding: 0.3em 0.4em;
  font-size: 0.9em;
  border-radius: 3px;
  border: solid 1px #ededed;
  outline: none;
  transition: box-shadow 0.3s var(--heim-transition);
  margin-bottom: 0.8em;
}
input.paper-input:hover,
input.paper-input:focus {
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
}
.heim-input[icon] input.paper-input {
  padding-right: 32px;
}

.date-input {
  margin-bottom: 20px;
}
</style>

<style scoped>
.toggle-box {
  font-size: 0.8em;
  color: rgba(0, 0, 0, 0.65);
  font-weight: 500;
  display: flex;
  align-items: center;
}
.toggle-box .label {
  display: inline-block;
  margin-bottom: 0.6em;
}

.heim-input .label {
  display: inline-block;
  font-size: 0.8em;
  color: rgba(0, 0, 0, 0.65);
  margin-bottom: 0.1em;
  font-weight: 500;
}
</style>
